import { MailMergeTemplate } from '@/types/MailMergeTypes'
import { PagedListModel } from '@/types/utilTypes'
import axios, { AxiosResponse } from 'axios'
import { ILoggingService } from './LoggingService'

export default class MailMergeService {
    private readonly _logging: ILoggingService
    private readonly baseUrl = '/mail-merge'

    constructor(logging: ILoggingService) {
        this._logging = logging
    }

    public async getTemplates(
        page: number,
        pageSize: number,
        pageName: string,
        search?: string
    ): Promise<PagedListModel<MailMergeTemplate>> {
        const url = `${this.baseUrl}/templates/${pageName}`
        try {
            const response = await axios.get<PagedListModel<MailMergeTemplate>>(url, {
                params: {
                    page,
                    pageSize,
                    ...(search ? { search } : {}),
                },
            })
            return response.data
        } catch (error) {
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async upsertTemplate(form: FormData): Promise<void> {
        const url = `${this.baseUrl}/templates/`
        try {
            await axios.post(url, form)
        } catch (error) {
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async deleteTemplate(id: string): Promise<void> {
        const url = `${this.baseUrl}/templates/${encodeURIComponent(id)}`
        try {
            await axios.delete(url)
        } catch (error) {
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async downloadTemplate(id: string ): Promise<AxiosResponse<Blob>> {
        const url = `${this.baseUrl}/templates/download/${encodeURIComponent(id)}`
        try {
            const response = await axios.get(
                url, 
                {responseType: 'blob'}
            )

            return response
        } catch (error) {
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async templateReplace(record: Record<string,string>, id: string): Promise<AxiosResponse<Blob>> {
        const url = `${this.baseUrl}/replace`
        try {
            const response = await axios.post(
                url, 
                {
                    id,
                    replacements: record
                },
                {responseType: 'blob'}
            )

            return response
        } catch (error) {
            this._logging.LogError(url, error)
            throw error
        }
    }

}